var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "column-edit-size" },
    [
      _c("el-input", {
        attrs: { type: "number", size: "mini", "data-index": "sizeLength" },
        on: { input: _vm.handleChange },
        model: {
          value: _vm.sizeLength,
          callback: function($$v) {
            _vm.sizeLength = _vm._n($$v)
          },
          expression: "sizeLength"
        }
      }),
      _c("span", [_vm._v("*")]),
      _c("el-input", {
        attrs: { type: "number", size: "mini", "data-index": "sizeWidth" },
        on: { input: _vm.handleChange },
        model: {
          value: _vm.sizeWidth,
          callback: function($$v) {
            _vm.sizeWidth = _vm._n($$v)
          },
          expression: "sizeWidth"
        }
      }),
      _c("span", [_vm._v("*")]),
      _c("el-input", {
        attrs: { type: "number", size: "mini", "data-index": "sizeHeight" },
        on: { input: _vm.handleChange },
        model: {
          value: _vm.sizeHeight,
          callback: function($$v) {
            _vm.sizeHeight = _vm._n($$v)
          },
          expression: "sizeHeight"
        }
      }),
      _c("span", [_vm._v("*")]),
      _c("el-input", {
        attrs: { type: "number", size: "mini", "data-index": "sizeQuantity" },
        on: { input: _vm.handleChange },
        model: {
          value: _vm.sizeQuantity,
          callback: function($$v) {
            _vm.sizeQuantity = _vm._n($$v)
          },
          expression: "sizeQuantity"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }